import { useTheme as useStyledTheme } from 'styled-components';
/**
 * Get current theme values
 * Had to re-type as styled DefaultTheme doesn't have our current theme values
 */
export var useTheme = function () {
    return useStyledTheme();
};
//# sourceMappingURL=useTheme.js.map